import { useFirestoreGeneral } from "../../firebase/useFirestore"

const SubTargetgroupsCount = ({ targetgroupId }) => {

  const subTargetgroups = useFirestoreGeneral('SubTargetgroups', 'TargetgroupID', targetgroupId)

  return (
    <>{subTargetgroups.length}</>
  )
}

export default SubTargetgroupsCount